import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PrependBaseUrlPipe } from '../../pipes/prepend-base-url.pipe';
import { MediaDTO } from '../../models/media-dto';

@Component({
  selector: 'app-media',
  imports: [CommonModule, PrependBaseUrlPipe],
  standalone: true,
  templateUrl: './media.component.html',
  styleUrl: './media.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaComponent {
  @Input() media?: MediaDTO;
}
